"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex'
    },
    constraint: {
        backgroundColor: ({ backgroundColor }) => theme[backgroundColor] || theme.grey7,
        borderRadius: 7.5,
        fontSize: 10,
        fontWeight: 400,
        color: ({ color }) => theme[color] || theme.grey3,
        lineHeight: '15px',
        paddingLeft: 7,
        paddingRight: 7
    }
});
//# sourceMappingURL=tally.style.js.map